import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { Button } from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';

import { signOut } from "firebase/auth";

import { auth } from "../../config/firebase";


export const useLogout = ()=> {
    const [disabled, setDisabled] = useState(false);
    const navigate = useNavigate();

    const logout = () => {
        setDisabled(true);
        signOut(auth)
            .then(() => {
                sessionStorage.clear();
                navigate('/login');
            })
            .catch((error) => {
                console.error(error);
                setDisabled(false);
            });
    };

    return { disabled, logout };
};

interface LogoutButtonProps {
    text: string;
    size?: 'small' | 'medium' | 'large';
    fullWidth?: boolean;
}

const LogoutButton: React.FC<LogoutButtonProps> = ({ text, size = 'medium', fullWidth = false }) => {
    const { disabled, logout } = useLogout();

    return (
        <Button
            disabled={disabled}
            onClick={logout}
            variant="contained"
            startIcon={<LogoutIcon />}
            sx={{ mt: 0, mb: 0 }}
            size={size}
            fullWidth={fullWidth}
        >
            {text}
        </Button>
    );
};

export default LogoutButton;
